export default __webpack_public_path__ + "static/product-img-2601f6c6fe2b3865efc75595f12adc2f.png";